import { Card, Flex, Typography } from "antd";
import type { ReactNode } from "react";
import StarRatingIcon from "../../../../../assets/icons/StarRatingIcon";
import { cn } from "../../../../../utils/global.utils";
import CompletionIcon from "../../_icons/CompletionIcon";
import EnrollmentIcon from "../../_icons/EnrollmentIcon";
import LearnerIcon from "../../_icons/LearnerIcon";
import RatingIcon from "../../_icons/RatingIcon";
import UpIncrementIcon from "../../_icons/UpIncrementIcon";

const { Text, Title } = Typography;

interface MetricCardProps {
  title: string;
  value: ReactNode;
  trend?: string;
  trendType?: "up" | "down";
  subValue?: string;
  icon: React.ReactNode;
}

const MetricCard = ({
  title,
  value,
  trend,
  trendType,
  subValue,
  icon,
}: MetricCardProps) => (
  <Card className="shadow-sm bordered-card custom-card h-full">
    <Flex justify="space-between" align="center">
      <div className="space-y-2">
        <Text className="text-theme-slate-600 text-base font-normal">
          {title}
        </Text>
        <Flex className="space-y-1 flex-col justify-between">
          <Title
            level={3}
            className="!mb-0 text-theme-zinc-800 !text-3xl font-bold"
          >
            {value}
          </Title>
          {trend && (
            <Flex
              align="center"
              gap={4}
              className={cn("text-sm font-normal mt-3")}
            >
              {trendType === "up" && <UpIncrementIcon />}
              <Text
                className={cn(
                  trendType === "up"
                    ? "text-theme-success-600"
                    : "text-theme-error-500"
                )}
              >
                {trend}
              </Text>
              <Text
                className={cn(
                  trendType === "up"
                    ? "text-theme-success-600"
                    : "text-theme-error-500"
                )}
              >
                this month
              </Text>
            </Flex>
          )}
          {subValue && (
            <Text className="text-theme-slate-500 text-sm font-normal mt-auto block">
              {subValue}
            </Text>
          )}
        </Flex>
      </div>
      <div>{icon}</div>
    </Flex>
  </Card>
);

export default function MetricCards() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <MetricCard
        title="Total Learners"
        value="25,000"
        trend="+12%"
        trendType="up"
        icon={<LearnerIcon />}
      />
      <MetricCard
        title="Total Enrollments"
        value="25K"
        trend="+12%"
        trendType="up"
        icon={<EnrollmentIcon />}
      />
      <MetricCard
        title="Average Rating"
        value={
          <Flex
            align="center"
            gap={4}
            className="text-theme-slate-700 text-base font-normal"
          >
            <StarRatingIcon />
            4.9
          </Flex>
        }
        subValue="143 reviews"
        icon={<RatingIcon />}
      />
      <MetricCard
        title="Completion Rate"
        value="85%"
        subValue="243 Completed"
        icon={<CompletionIcon />}
      />
    </div>
  );
}
